import T from "./TheTool";

class TG {
	static txt_differentN(arr1, arr2) {
		let txt = "The number of items are different. Please check your data.";
		txt += `<br/>Sample 1 (n=${arr1.length}): ${arr1}<br/>Sample 2 (n=${arr2.length}): ${arr2}`;
		return txt;
	}
	static txt_normalDistribution(header, b_normal) {
		return b_normal
			? `Data from ${header} are normally distributed.`
			: `Data from ${header} are not normally distributed.`;
	}
	static txt_normalityTest(n, n_notNormal, suggestPara, suggestNonPara) {
		//n < 30? and how many do not follow normal distribution
		let txt = "";
		if (n < 30) {
			txt += "The data size is small (<30 pairs)";
			if (n_notNormal == n) {
				txt += " and the data do not follow normal distribution";
			} else if (n_notNormal > 0) {
				txt += " and some data do not follow normal distribution";
			} else {
				txt += ", although the data follow normal distribution";
			}
			txt += `, it is suggested to use the non-parametric test (${suggestNonPara}).`;
		} else if (n > 0) {
			txt += n == n_notNormal ? "The" : "Some";
			txt += ` data do not follow normal distribution, it is suggested to use the non-parametric test (${suggestNonPara}).`;
		} else {
			txt +=
            `The data size is large enough (>=30 pairs) and the data follow normal distribution, it is suggested to use the parametric test (${suggestPara}).`;
		}
        return txt;
	}
	static txt_ttest_sig(b_sig, mean1, sd1, mean2, sd2, ci) {
        //ci as text
        //alpha: 0.05
        // let ci = 1 - alpha;
        let a =  (b_sig) ? "a " : "no ";
		let txt =  `There is ${a} significant difference between Sample 1 (M = ${mean1} SD = ${sd1}) and Sample 2 (M = ${mean2} SD = ${sd2}) at ${ci} Confident Interval`;
        return txt;
    }
    static txt_sig(b_sig, ci) {
        let a =  (b_sig) ? "a " : "no ";
        let txt =  `There is ${a} significant difference between Sample 1 and Sample 2 at ${ci} Confident Interval`;
        return txt;
    }
    static txt_n_toofew(txt) {
        return  `The data has < ${txt}, reliable result cannot be acheived.`;
    }
    static txt_n_suggest(txt) {
        return  `It is suggested to has at least ${txt} of data for reliable results.`;
    }

}
export default TG;
